import React, { Component } from 'react';
import { Popover, Icon } from 'antd';
import { connect } from 'react-redux';
import IntlMessages from '../../components/utility/intlMessages';
import TopbarDropdownWrapper from './topbarDropdown.style';
import notification from '../../components/notification';
import FetchHelper from '../../helpers/fetchHelper';


class TopbarTickets extends Component {
  constructor(props) {
    super(props);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.gotoTicket = this.gotoTicket.bind(this);
    this.hide = this.hide.bind(this);
    this.state = {
    visible: false,
    tickets:[]
   };
  }
  componentDidMount(){
    this.retrieveData();
    /*this.interval = setInterval(() => {
      this.retrieveData();
    }, 85000);*///5000
  }
  componentWillUnmount(){
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
  retrieveData(){
    FetchHelper.httpRequest('GET', 'tickets/estados?filter=Procesando,Espera').then(result => {
      if (result.error) {
        //notification('error', result.error_msg);
      } else {
        var tickets = result.data.datos;
        var ticketsPropietario = [];
        for (var i = 0; i < tickets.length; i++) {
          if (tickets[i].propietario === true) {
            ticketsPropietario.push(tickets[i])
          }
        }
        this.setState({tickets:ticketsPropietario})
      }
    });
  }
  hide(){
    this.setState({ visible: false });
  }
  handleVisibleChange() {
    this.setState({ visible: !this.state.visible });
  }
  gotoTicket(id){
    this.hide();
    this.props.history.push({pathname: "/dashboard/solicitud/"+id, id:id});
  }
  gotoDashboard(){
    this.hide();
    this.props.history.push({pathname: "/dashboard/sau/"});
  }
  render() {
    const { tickets } = this.state;
    const content = (
      <TopbarDropdownWrapper className="topbarNotification">
        <div className="isoDropdownHeader">
          <h3>Mis solicitudes</h3>
        </div>
        {
          tickets &&  tickets.length > 0 ?
          <div className="isoDropdownBody">
            {tickets.map(item => (
              <div key={item.id} className="isoTicketsWrapper" onClick={(event) => this.gotoTicket(item.id)}>
                <div className={`isoTicketIcon isoTicketIconEstado_${item.ticketEstado}`}>
                  <Icon type={
                    item.ticketEstado === 'Nuevo' ?
                    'alert'
                    : item.ticketEstado === 'Procesando' ?
                    'solution'
                    : item.ticketEstado === 'Espera' ?
                    'clock-circle'
                    : item.ticketEstado === 'Cerrado' ?
                    'file-done'
                    :
                    null
                  }/>
                </div>
                <div className="isoTicket">
                  <h4>Nº <b>{item.id} </b>{item.ticketCategoria?item.ticketCategoria.nombre:''} {item.ticketSubCategoria?item.ticketSubCategoria.nombre:''}</h4>
                  {
                    item.titular && item.titular.nombre && item.titular.apellido?
                    <p>{item.titular.apellido+', '+item.titular.nombre}</p>
                    :
                    <p>Anonimo</p>
                  }
                </div>
              </div>
            ))}
          </div>
          :
          <div className="isoDropdownHeader">
            <h4>No tienes solicitudes en proceso o en espera</h4>
          </div>
        }
        <div className="isoViewAllBtn" style={{cursor: 'pointer'}} onClick={(event) => this.gotoDashboard()}>
          <IntlMessages id="topbar.viewAll" />
        </div>
      </TopbarDropdownWrapper>
    );
    return (
      <Popover
        content={content}
        trigger="click"
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
        placement="bottomLeft"
      >
        <div className="isoIconWrapper">
          <Icon type='solution'/>
          {
            tickets.length > 0 ?
            <span>{tickets.length}</span>
            :null
          }
        </div>
      </Popover>
    );
  }
}

export default connect(state => ({
  ...state.Telepase
}))(TopbarTickets);
